var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    { attrs: { title: _setup.t("Врачи", _setup.options) } },
    _vm._l(_setup.context.specialities, function (speciality) {
      return _c(
        "a",
        {
          key: speciality.translit,
          staticClass:
            "d-table text--text link-decoration-none mb-4 text-body-1",
          attrs: {
            "data-qa": "doctor-list",
            href: _setup.reverseFullL10N({
              name: "town_speciality",
              args: {
                spec_translit: speciality.translit,
                language: _setup.urlLang,
              },
            }),
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.transDynamic(
                  speciality,
                  `name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }